import { differenceInYears, intervalToDuration, isValid, parseISO } from "date-fns";

const ADULT_AGE = 18;

export function verifyIfTalentIsAdult(birthDate: string | Date): boolean {
  const birth = parseBirthDate(birthDate);

  if (!birth) {
    return false;
  }

  return differenceInYears(new Date(), birth) >= ADULT_AGE;
}

export function formatTalentAge(birthDate: string | Date, referenceDate: Date = new Date()): string {
  const birth = parseBirthDate(birthDate);

  if (!birth || birth > referenceDate) {
    return "";
  }

  const { years = 0, months = 0 } = intervalToDuration({ start: birth, end: referenceDate });
  const yearLabel = years === 1 ? "ano" : "anos";
  const monthLabel = months === 1 ? "mês" : "meses";

  return `${years} ${yearLabel} e ${months} ${monthLabel}`;
}

function parseBirthDate(birthDate: string | Date): Date | null {
  let birth = typeof birthDate === "string" ? parseISO(birthDate) : birthDate;

  if (!isValid(birth)) {
    birth = new Date(birthDate);
  }

  return isValid(birth) ? birth : null;
}
